import DynamicRoutes from '@lib/routes/DynamicRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import getEnrichedText from '@lib/utilities/enrichTextInMarkdown/getEnrichedText'

const MAX_ENRICHMENTS_ADDED = 5

function replacePreserveCase({
  find,
  keyword,
  link,
  str,
}: {
  find: RegExp
  keyword: string
  link: string
  str: string
}): string {
  // check if the keyword is already in a link in the string
  const keywordInLink = new RegExp(
    `\\[[^\\]]*${keyword}[^\\]]*\\]\\([^)]*\\)`,
    'g',
  )
  if (keywordInLink.test(str)) {
    return str
  }

  return str.replace(find, function (match) {
    const firstChar = match.charAt(0)
    const isAllCaps = match === match.toUpperCase()

    if (isAllCaps) {
      return `[${keyword.toUpperCase()}](${link})`
    } else if (firstChar === firstChar.toUpperCase()) {
      return `[${keyword.charAt(0).toUpperCase()}${keyword.slice(1)}](${link})`
    } else {
      return `[${keyword}](${link})`
    }
  })
}

export default function getEnrichedTextInMarkdown(answer: string): string {
  // Detect answers that already have markdown links already and don't modify them
  const existingMarkdownLinks = new RegExp(/\[[^\]]*\]\([^)]*\)/g, 'g')
  if (answer.search(existingMarkdownLinks) > -1) {
    return answer
  }

  const { enrichments } = getEnrichedText(answer)

  // Sliding window to add up to MAX_ENRICHMENTS_ADDED enrichments
  let enrichedAnswer = answer
  let enrichmentsAdded = 0

  // check if any enrichments are already in the answer

  for (let i = 0; i < enrichments.length; i++) {
    if (i >= MAX_ENRICHMENTS_ADDED) {
      break
    }
    const enrichment = enrichments[i]
    if (!enrichment) {
      continue
    }
    const slug = enrichment.links.find((link) => link.label === 'topic')?.url
    if (!slug) {
      continue
    }
    const link = absoluteUrl(DynamicRoutes.topic(slug))

    enrichedAnswer = replacePreserveCase({
      find: enrichment.matcher,
      keyword: enrichment.keyword,
      link,
      str: enrichedAnswer,
    })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    enrichmentsAdded++
  }

  return enrichedAnswer
}
